import { Component, HostBinding, inject, input } from '@angular/core';
import { PanelComponent as IaPanelComponent } from '@bcef/ia-components/panel';
import { ContextService } from '@bcef/ia-shared';
import { clsx } from 'clsx';

@Component({
  selector: 'ia-report-technical-problem-panel',
  template: `
    <ia-panel [hideBorder]="context.isHbPro" [hideHeader]="context.isHbGroup">
      <h2
        header
        class="hbpro:tw-text-2xl hbpro:tw-tracking-normal nhb:tw-text-hb-md mb-group:tw-px-3 mb-group:tw-text-lg hb-group:tw-font-medium hb-group:tw-leading-tight"
      >
        {{ title() }}
      </h2>
      <div
        content
        class="nhb:tw-p-6 mb-group:tw-space-y-7.5 mb-group:tw-px-7.5 mb-group:tw-py-10 hb-group:tw-pb-6"
      >
        <ng-content />
      </div>
    </ia-panel>
  `,
  imports: [IaPanelComponent],
})
export class PanelComponent {
  public readonly title = input.required<string>();

  protected readonly context = inject(ContextService);

  @HostBinding('class')
  public classAttributes = clsx([
    'hbpro:[&_.ia-panel-header-container]:tw-bg-transparent',
    'hbpro:[&_.ia-panel-header-container]:tw-p-0',
    'nhb:[&_.ia-panel-header-container]:tw-min-h-0',
  ]);
}
